import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { restoreOrganizationRequest } from "@requests/restore-organization";
import { updateOrganizations } from "@redux/actions/organizations-actions";

export const restoreOrganizationReduxRequest = (dispatch: Dispatch) => async (
    organizationId: string
): Promise<AxnCompany> => {
    const { data, error } = await restoreOrganizationRequest(organizationId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.restoreOrganization.success.title,
            resources.requests.restoreOrganization.success.message
        );
        dispatch(updateOrganizations(data.transferObject, GenericAccountStateTypes.RESTORE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.restoreOrganization.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};